import { Injectable } from '@angular/core';
import { FrameContext, BindingData } from '@farris/devkit';

@Injectable()
class EntityManipulationService {

  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  constructor(private frameContext: FrameContext) {
  }

  /**
   * è®¾ç½®pathå¯¹åºçå­æ®µå¼
   */
  public setPropValue(path: string[], value: any): any {

    // å®ä½å±è¿æ²¡æå°è£ï¼ä¸´æ¶ç¨BindingDataç¸å³æ¹æ³ä»£æ¿
    this.bindingData.setValue(path, value, true, true);
  }

}

export { EntityManipulationService };
